import { Grid } from '@material-ui/core';
import { EntityAboutCard, EntityHasComponentsCard, /*EntityHasResourcesCard,*/ EntityLayout, EntityLinksCard } from '@backstage/plugin-catalog';

import { EntityRelationsGraph } from '@backstage/plugin-catalog-graph';
import { useEntity } from '@backstage/plugin-catalog-react';

import {
  RELATION_API_CONSUMED_BY,
  RELATION_API_PROVIDED_BY,
  RELATION_CONSUMES_API,
  RELATION_DEPENDENCY_OF,
  RELATION_DEPENDS_ON,
  RELATION_HAS_PART,
  RELATION_PART_OF,
  RELATION_PROVIDES_API,
} from '@backstage/catalog-model';


import { EntityWarningContent } from './modules/EntityWarningContent';
import { DebugTab } from './tabs/DebugTab';
import { ProvidedApiTable } from './modules/ProvidedApiTable';
import { ResourcesTable } from './modules/ResourcesTable';


function Overview() {
    return (
        <Grid container spacing={3} alignItems="stretch">
            <EntityWarningContent />

            <Grid item md={8}>
                <EntityAboutCard />
            </Grid>
            
            <Grid item md={4} xs={12}>
                <EntityLinksCard />
            </Grid>
            
            <Grid item md={12}>
                <EntityHasComponentsCard />
            </Grid>
            
        </Grid>
    );
}

function Diagram() {
    const { entity } = useEntity();
    return (
        <EntityRelationsGraph
            rootEntityNames={{ kind: entity.kind || '', namespace: entity.metadata.namespace || '', name: entity.metadata.name || '' }}
            maxDepth={2}
            relations={[
                RELATION_PART_OF,
                RELATION_HAS_PART,
                RELATION_API_CONSUMED_BY,
                RELATION_API_PROVIDED_BY,
                RELATION_CONSUMES_API,
                RELATION_PROVIDES_API,
                RELATION_DEPENDENCY_OF,
                RELATION_DEPENDS_ON,
            ]}
            unidirectional={false}
        />
    );
}
export const systemPage = (
    <EntityLayout>
        <EntityLayout.Route path="/" title="Overview">
            <Overview />
        </EntityLayout.Route>

        <EntityLayout.Route path="/diagram" title="Diagram">
            <Diagram />
        </EntityLayout.Route>

        <EntityLayout.Route path="/api" title="APIs">
            <Grid container spacing={3} alignItems="stretch">                
                <Grid item md={12}>            
                    <ProvidedApiTable />
                </Grid>
            </Grid>
        </EntityLayout.Route>

        <EntityLayout.Route path="/resources" title="Resources">
            <Grid container spacing={3} alignItems="stretch">                
                <Grid item md={12}>               
                    <ResourcesTable />
                </Grid>
            </Grid>       
        </EntityLayout.Route>

        <EntityLayout.Route path="/debug" title="Debug">
            <DebugTab />
        </EntityLayout.Route>

    </EntityLayout>
);
